

export default {
    components: {
        
    },
    data() {
        return {
            isSubmitting: false,
            termsError: false,
            acceptsTerms: false
        }
    },
    created: function () {
        this.isSubmitting = false;
        this.termsError = false;
        this.acceptsTerms = false;
    },
    watch: {
        acceptsTerms: function(val){
            this.acceptsTerms = val;
            this.termsError = false;
        }
    },
    methods: {
        submitForm(e) {
            this.isSubmitting = true;
            
            if (!this.acceptsTerms) {
                this.termsError = true;
                this.isSubmitting = false;

                return false;
                
            } else {
                if (!this.termsError) {
                    e.target.form.submit();
                }
            }
        }
    } 
}